import React, { FunctionComponent } from 'react'
import { Button, Heading, IconAvatar, Link, Modal, Skeleton, Text, useMoney } from '@afterpaytouch/core'
import { Trans, useTranslation } from 'next-i18next'
import { useAppDispatch, useAppRouter, useGetCreditLimitQuery, useWelcomeWithInitialLimitStatus } from '../../../state'
import { WelcomeWithInitialLimitStatus, setWelcomeWithInitialLimitSeen } from '../../../state/registration/reducer'
import { useUkRegFlags } from '../../../hooks/useUkRegFlags/useUkRegFlags'
import { useConsumerSizes } from '../../../utils/responsive'
import styles from './style.module.scss'

const I18N_NAMESPACE = ['welcomeWithInitialLimit', 'common']

export const WelcomeWithInitialLimitModal: FunctionComponent = () => {
  const { t } = useTranslation(I18N_NAMESPACE)
  const dispatch = useAppDispatch()
  const router = useAppRouter()
  const { headingSize, textSize } = useConsumerSizes()
  const { isGbRegFlow } = useUkRegFlags()
  const welcomeStatus = useWelcomeWithInitialLimitStatus()
  const { data: creditLimitData, isLoading } = useGetCreditLimitQuery()
  const { formatMoney } = useMoney({
    locale: router.locale,
    currency: creditLimitData?.creditLimit?.currency,
  })

  const isEligible = isGbRegFlow && welcomeStatus === WelcomeWithInitialLimitStatus.Eligible

  if (!isEligible) {
    return null
  }

  const handleContinue = (): void => {
    dispatch(setWelcomeWithInitialLimitSeen())
  }

  return (
    <Modal show onBackdropClick={handleContinue} backdropKind='Darker'>
      <Modal.Content>
        <div className={styles.container}>
          <div className={styles.icon}>
            <IconAvatar iconName='Check' backgroundColor='Bondi Mint' size='L' testNameSpace='welcome-check-icon' />
          </div>
          <div className={styles.heading}>
            <Heading size={headingSize}>{t('welcomeWithInitialLimit:heading')}</Heading>
          </div>
          <div className={styles.subtitle}>
            <Text size={textSize}>{t('welcomeWithInitialLimit:subtitle')}</Text>
          </div>
          <div className={styles.amount}>
            {isLoading ? (
              <Skeleton kind='Default' />
            ) : (
              creditLimitData?.creditLimit != null && <Heading size='XXXXL'>{formatMoney(creditLimitData.creditLimit.amount)}</Heading>
            )}
          </div>
          <div className={styles.estimatedSpend}>
            <Text size={textSize}>{t('welcomeWithInitialLimit:estimatedSpend')}</Text>
          </div>
          <div className={styles.terms}>
            <Text size='XS' color='Subtle'>
              <Trans
                i18nKey='welcomeWithInitialLimit:terms'
                components={{
                  creditContractLink: <Link kind='Underline' href={t('welcomeWithInitialLimit:creditContractUrl')} target='_blank' />,
                }}
              />
            </Text>
          </div>
          <div className={styles.cta}>
            <Button.Primary size='Large' padding='Fluid' onClick={handleContinue} testNameSpace='welcome-initial-limit-continue'>
              {t('welcomeWithInitialLimit:continue')}
            </Button.Primary>
          </div>
        </div>
      </Modal.Content>
    </Modal>
  )
}
